export default "__VITE_ASSET__2850f0b4__"